import {
    GET_SPECIFIC_MODULE_SUCCESS,
    GET_SPECIFIC_MODULE_ERROR
    } from "../../actionTypes/authActionTypes";
    import initialState from "../../store/initialState";
    
    const reducer = (state = initialState, action) => {
      switch (action.type) {
        case GET_SPECIFIC_MODULE_SUCCESS:
          return {
            ...state,
            singleModuleData: action.payload,
          };
        case GET_SPECIFIC_MODULE_ERROR:
          return {
            ...state,
            singleModuleError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    